import {getRequest, sendRequest} from './api';

/**
 * Получение списка отделов.
 * @returns {Promise<any>} - Ответ от сервера.
 */
export async function fetchDepartments(organisation_id) {
  return getRequest('/department', {organisation_id});
}

/**
 * Создание нового отдела.
 * @param {object} data - Данные для создания отдела.
 * @param {string} data.organisation_id - Идентификатор организации (обязательный).
 * @param {string} data.name - Название отдела (обязательный).
 * @param {string} [data.parent_department_id] - Идентификатор родительского отдела (необязательный).
 * @returns {Promise<any>} - Ответ от сервера.
 */
export async function createDepartment(data) {
  return sendRequest('/department', 'POST', data);
}

/**
 * Обновление отдела.
 * @param {object} data - Данные для обновления отдела.
 * @param {string} data.organisation_id - Идентификатор организации (обязательный).
 * @param {string} data.name - Название отдела (обязательный).
 * @returns {Promise<any>} - Ответ от сервера.
 */
export async function updateDepartment(data) {
  return sendRequest('/department', 'PUT', data);
}

/**
 * Удаление отдела.
 * @param {object} data - Данные для удаления отдела.
 * @param {string} data.id - Идентификатор отдела (обязательный).
 * @param {string} data.organisation_id - Идентификатор организации (обязательный).
 * @returns {Promise<any>} - Ответ от сервера.
 */
export async function deleteDepartment(data) {
  return sendRequest('/department', 'DELETE', data);
}
